import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaCogs,
  FaIndustry,
  FaChartLine,
  FaUsers,
  FaDatabase,
  FaFileExcel,
  FaClock,
  FaShieldAlt,
  FaDownload,
  FaCheckCircle,
  FaStar,
  FaArrowRight,
  FaCode,
  FaCloud,
  FaMobile,
  FaSync,
} from "react-icons/fa";
import "./VyrobaWebPage.css";

const VyrobaWebPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const features = [
    {
      icon: FaFileExcel,
      title: "Migrácia z Excel",
      description:
        "Automatický presun a transformácia dát z Excel súborov do moderného webového prostredia",
    },
    {
      icon: FaIndustry,
      title: "Digitalizácia procesov",
      description:
        "Kompletná digitalizácia výrobných procesov s možnosťou customizácie podľa potrieb",
    },
    {
      icon: FaDatabase,
      title: "MSSQL databáza",
      description:
        "Robustné databázové riešenie pre spoľahlivé ukladanie a správu výrobných dát",
    },
    {
      icon: FaSync,
      title: "Real-time komunikácia",
      description:
        "SignalR technológia pre okamžitú synchronizáciu dát medzi užívateľmi",
    },
    {
      icon: FaCode,
      title: "React + C# platforma",
      description:
        "Moderné technológie zabezpečujúce rýchlosť, bezpečnosť a škálovateľnosť",
    },
    {
      icon: FaChartLine,
      title: "Pokročilý reporting",
      description:
        "Interaktívne reporty a analýzy s možnosťou exportu do rôznych formátov",
    },
  ];

  const benefits = [
    {
      icon: FaClock,
      title: "Úspora času",
      value: "70%",
      description: "Zníženie času na správu výrobných dát",
    },
    {
      icon: FaChartLine,
      title: "Efektivita procesov",
      value: "50%",
      description: "Zvýšenie produktivity výrobných liniek",
    },
    {
      icon: FaDatabase,
      title: "Presnosť dát",
      value: "99%",
      description: "Eliminovanie chýb pri manuálnom zadávaní",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť užívateľov",
      value: "95%",
      description: "Vyššia spokojnosť vďaka intuitívnemu rozhraniu",
    },
  ];

  const packages = [
    {
      name: "BASIC VÝROBA",
      price: "599€",
      description: "Pre malé výrobné podniky",
      features: [
        "Migrácia z Excel súborov",
        "Základný reporting",
        "Web rozhranie",
        "MSSQL databáza",
        "Do 3 používateľov",
        "Email podpora",
      ],
    },
    {
      name: "STANDARD VÝROBA",
      price: "999€",
      description: "Pre stredné výrobné spoločnosti",
      features: [
        "Všetky funkcie BASIC",
        "SignalR real-time sync",
        "Pokročilé reporty",
        "Material-UI rozhranie",
        "Do 10 používateľov",
        "Mobilná responzivita",
        "Prioritná podpora",
      ],
      popular: true,
    },
    {
      name: "PREMIUM VÝROBA",
      price: "1599€",
      description: "Pre veľké priemyselné podniky",
      features: [
        "Všetky funkcie STANDARD",
        "Custom funkcionalita",
        "API integrácie",
        "Advanced analytics",
        "Neobmedzený počet používateľov",
        "Podpora 24/7",
        "Onsite školenia a konzultácie",
      ],
    },
  ];

  const industries = [
    {
      icon: FaIndustry,
      title: "Automobilový priemysel",
      description: "Sledovanie výroby vozidiel a komponentov",
    },
    {
      icon: FaCogs,
      title: "Strojárstvo",
      description: "Riadenie výroby strojov a zariadení",
    },
    {
      icon: FaCode,
      title: "Elektronický priemysel",
      description: "Správa výroby elektronických súčiastok",
    },
    {
      icon: FaCloud,
      title: "Potravinárstvo",
      description: "Monitorovanie kvality a výrobných procesov",
    },
  ];

  const testimonials = [
    {
      name: "Ing. Martin Kovár",
      company: "AUTO-TECH s.r.o.",
      text: "VyrobaWeb nám kompletne zdigitalizovala výrobné procesy. Prechod z Excel tabuliek bol hladký a rýchly.",
      rating: 5,
    },
    {
      name: "Jana Horváthová",
      company: "STEEL WORKS",
      text: "Real-time reporting a synchronizácia dát medzi oddeleniami nám ušetrila hodiny práce denne.",
      rating: 5,
    },
  ];

  const technologies = [
    { name: "React", color: "#61dafb" },
    { name: "C#", color: "#239120" },
    { name: "MSSQL", color: "#cc2927" },
    { name: "SignalR", color: "#512bd4" },
    { name: "MUI", color: "#007fff" },
  ];

  return (
    <div className="vyrobaweb-page">
      {/* Hero Section */}
      <section className="vyrobaweb-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>VyrobaWeb</h1>
              <h2>Digitalizácia výrobných procesov</h2>
              <p>
                Digitalizácia a presun procesov z Excelu do moderného webového
                prostredia. Jednoduchšia správa, zdieľanie a reporting výrobných
                dát s využitím najmodernejších technológií.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/vyrobaweb.png" alt="VyrobaWeb" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Použité technológie</h2>
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="tech-name" style={{ color: tech.color }}>
                  {tech.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy výrobných podnikov</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section
      <section className="pricing-section">
        <div className="container">
          <h2>Cenové balíčky</h2>
          <div className="pricing-grid">
            {packages.map((pkg, index) => (
              <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
                {pkg.popular && <div className="popular-badge">Najpopulárnejší</div>}
                <h3>{pkg.name}</h3>
                <div className="price">{pkg.price}</div>
                <p className="price-description">{pkg.description}</p>
                <ul className="features-list">
                  {pkg.features.map((feature, fIndex) => (
                    <li key={fIndex}>
                      <FaCheckCircle />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button className="btn btn-primary">
                  Vybrať balíček
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <h2>Čo hovoria naši klienti</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-content">
                  <p>"{testimonial.text}"</p>
                  <div className="testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="testimonial-author">
                  <h5>{testimonial.name}</h5>
                  <span>{testimonial.company}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Náš klient</h2>
          <div className="customers-grid">
            <a 
              href="https://www.crocodille.com/cs/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/crocodille_logo.png" alt="Crocodille ČR" />
              <h3>Crocodille ČR, spol. s r. o.</h3>
              <p>Firma Crocodille ČR sa zaoberá výrobou a predajom v segmente FMCG (obložené bagety a sendviče). Je dlhodobo jednotkou trhu v Českej republike.</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VyrobaWebPage;
